module.exports = __webpack_public_path__ + "2001_a_space_odyssey.f4e3d01d.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/img/cinema/2001_a_space_odyssey.jpg
// module id = cL5C
// module chunks = 0